<template>
  <div>
    <!--<h3>Report Basic</h3>-->
    <!--<input type="button" value="Run Report" @click="createReport" />-->
    <div class="reportView page right-side" size="A4"></div>
  </div>
</template>
<script>
  // import jsreports from 'lib/jsreports.js'
  export default {
    name: 'reportBasic',
    props: {
      isActive: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        orderData: [{
          userId: '1X39AN4Z92Y',
          userName: 'John Smith',
          accountType: 'INDIVIDUAL',
          orderTotal: 19.95,
          orderDate: '2016-02-24'
        }, {
          userId: '1AC43L30HR8',
          userName: 'Alison Jones',
          accountType: 'BUSINESS',
          orderTotal: 180.50,
          orderDate: '2016-02-25'
        }, {
          userId: '1CM499NA94R',
          userName: 'Becky Sanderson',
          accountType: 'BUSINESS',
          orderTotal: 85.00,
          orderDate: '2016-02-27'
        }],
        orderSchema: {
          fields: [{
            name: 'userId',
            type: 'text'
          }, {
            name: 'userName',
            type: 'text'
          }, {
            name: 'accountType',
            type: 'text'
          }, {
            name: 'orderTotal',
            type: 'number'
          }, {
            name: 'orderDate',
            type: 'date'
          }]
        },
        dataSource: {
          id: 'orders',   // Internal reference ID
          name: 'Orders',  // Data source name shown to report designer
          data: null,
          schema: null
        }
      }
    },
    created () {
      this.$root.title = 'Reports'
    },
    mounted () {
    },
    updated () {
    },
    watch: {
      isActive (val) {
        console.log('[reportBasic] isActive = ' + val)
        if (val) {
          this.createReport()
        }
      }
    },
    methods: {
      createReport () {
        const vm = this
        // var jsreports = null
        // Create a report definition
        var reportDef = jsreports.createReport()
          .data('orders') // The report will look for a data source with ID "orders"
          // .title('TEST REPORT 2019')
          // .groupBy('accountType', 'accountType', 'desc')
          .header(0.15)
          .text('[accountType] Accounts:')
          .footer(0.5)
          .text('Total: [SUM(orderTotal)]', 2, 0, 2, 0.25, {
            pattern: '$#,##0.00',
            align: 'right',
            bold: true
          })
          .detail()
          .text('[userName]')
          .text('[orderDate]', 1.75, 0, 1, 0.25, {
            pattern: 'M/D/YY'
          })
          .text('[orderTotal]', 3, 0, 1, 0.25, {
            pattern: '$#,##0.00',
            align: 'right'
          })
          .done()

        // console.log(report)
        vm.dataSource.data = vm.orderData
        vm.dataSource.schema = vm.orderSchema
        // console.log(vm.dataSource)

        // Render the report
        jsreports.render({
          report_def: reportDef,
          target: $('.reportView'),
          datasets: [vm.dataSource],
          scaleFonts: true
        })
      }
    }
  }
</script>
<style>
  .reportView {
    z-index: 200;
    min-height: 29.7cm;
  }

  .page {
    background: white;
    display: block;
    position: relative;
    min-height: 0;
    margin: 0 auto;
    padding: 0;
    margin-top: 0.5cm;
    margin-bottom: 0.5cm;
    /*box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);*/
    /*page-break-before: always;
    page-break-before: always;
    page-break-after: always;
    break-before: always;
    break-after: always;
    page-break-after: always;*/
    /*page-break-inside: avoid;*/
    page-break-after: always;
    page-break-inside: avoid;
  }

    .page[size="A4"] {
      width: 21cm;
      height: 29.7cm;
      /*height: 31.0cm;*/
      /*position: relative;*/
    }

      .page[size="A4"][layout="portrait"] {
        width: 29.7cm;
        height: 21cm;
      }

    .page[size="A3"] {
      width: 29.7cm;
      height: 42cm;
    }

      .page[size="A3"][layout="portrait"] {
        width: 42cm;
        height: 29.7cm;
      }

    .page[size="A5"] {
      width: 14.8cm;
      height: 21cm;
    }

      .page[size="A5"][layout="portrait"] {
        width: 21cm;
        height: 14.8cm;
      }
</style>



// WEBPACK FOOTER //
// ReportBasic.vue?0cf76632